export default "__VITE_ASSET__BaIFE1lT__"